"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.tradingDaysBetween = void 0;
const isTradingDay_1 = require("../isTradingDay");
const parseInputDate_1 = require("../../utils/parseInputDate");
function tradingDaysBetween(startDate, endDate) {
    const beginDateTime = (0, parseInputDate_1.parseInputDate)(startDate);
    const endDateTime = (0, parseInputDate_1.parseInputDate)(endDate);
    let newStartDate = beginDateTime;
    let newEndDate = endDateTime;
    let negative = false;
    let nTradingDays = 0;
    if (beginDateTime === endDateTime) {
        return 0;
    }
    if (beginDateTime > endDateTime) {
        negative = true;
        newStartDate = endDateTime;
        newEndDate = beginDateTime;
    }
    while (newStartDate < newEndDate && !(0, isTradingDay_1.isTradingDay)(newStartDate.toISODate())) {
        newStartDate = newStartDate.plus({ days: 1 });
    }
    while (newStartDate < newEndDate) {
        newStartDate = newStartDate.plus({ days: 1 });
        if ((0, isTradingDay_1.isTradingDay)(newStartDate.toISODate())) {
            nTradingDays++;
        }
    }
    if (negative && nTradingDays > 0) {
        return -1 * nTradingDays;
    }
    return nTradingDays;
}
exports.tradingDaysBetween = tradingDaysBetween;
//# sourceMappingURL=index.js.map